import { createNode } from '@glueapp/graph-types';

export const CheckApiKey = createNode({
    id: 'CheckApiKey',
    name: 'Check API Key',
    description: 'Find an API key header and compare its value against an expected key',
    category: 'API Server',
    color: '#808080',
    inPorts: {
        Headers: {
            kind: 'array',
            subType: {
                kind: 'object',
                properties: { name: { kind: 'string' }, value: { kind: 'string' } },
                restriction: 'exact',
            },
        },
        'Header Name': { kind: 'string' },
        'Expected Key': { kind: 'string' },
    },
    optionalInPorts: ['Expected Key'],
    outPorts: {
        Valid: { kind: 'boolean' },
        Value: { kind: 'string' },
    },
    execute: input => {
        const headers = input.inPorts.Headers as Array<{ name: string; value: string }> | null;
        const headerName = input.inPorts['Header Name'] as string | null;
        const expectedKey = input.inPorts['Expected Key'] as string | null;

        if (!headers || !Array.isArray(headers) || !headerName) {
            return { output: { Valid: false, Value: '' } };
        }

        const lowerName = headerName.toLowerCase();
        const matched = headers.find(header => header.name.toLowerCase() === lowerName);

        if (!matched || !matched.value) {
            return { output: { Valid: false, Value: '' } };
        }

        // If an expected key is provided, compare against it
        if (expectedKey) {
            const valid = matched.value === expectedKey;
            return { output: { Valid: valid, Value: matched.value } };
        }

        // No expected key — just check presence
        return { output: { Valid: true, Value: matched.value } };
    },
});
